$(document).ready(function(){
	$('.openVideosGallery').on('click', function(){
		setTimeout(function(){
			$.fancybox.open($('#sectionVideo [data-fancybox="videosGallery"]'));
		}, 800);
	});
});